module.exports = __webpack_public_path__ + "img/chessboard.453af628.png";